export function shouldShowMobileStickyCta({
  isHeroCtaVisible,
  isFinalCtaVisible,
  isFooterVisible,
}: {
  isHeroCtaVisible: boolean;
  isFinalCtaVisible: boolean;
  isFooterVisible: boolean;
}): boolean {
  return !isHeroCtaVisible && !isFinalCtaVisible && !isFooterVisible;
}
